import { render, staticRenderFns } from "./enterprise_label.vue?vue&type=template&id=71adccf6&scoped=true&"
import script from "./enterprise_label.vue?vue&type=script&lang=js&"
export * from "./enterprise_label.vue?vue&type=script&lang=js&"
import style0 from "./enterprise_label.vue?vue&type=style&index=0&id=71adccf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71adccf6",
  null
  
)

export default component.exports